import {
	ButtonProps as MantineButtonProps,
	Button as MantineButton,
	createPolymorphicComponent,
} from '@mantine/core';
import { useUnit } from 'effector-react';
import { ComponentPropsWithoutRef, forwardRef } from 'react';
import { clickSound } from 'shared/lib';

export type ButtonProps = {
	muted?: boolean;
} & MantineButtonProps &
	ComponentPropsWithoutRef<'button'>;

export const Button = createPolymorphicComponent<'button', ButtonProps>(
	// eslint-disable-next-line react/display-name
	forwardRef<HTMLButtonElement, ButtonProps>(({ muted, onClick, ...props }, ref) => {
		const playClick = useUnit(clickSound.play);

		return (
			<MantineButton
				{...props}
				ref={ref}
				onClick={(e) => {
					!muted && playClick();
					onClick?.(e);
				}}
			/>
		);
	}),
);

Button.displayName = 'Button';
